"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { cx } from "@/lib/tailwind-utils";
import { useAuthFlow } from "./auth-flow-context";
import { PhoneAuthStep, usePhoneAuthOptional } from "./methods/phone/phone-auth-context";
export interface AuthFlowHeaderProps {
  title?: ReactNode;
  description?: ReactNode;
  className?: string;
  /**
   * When this header is composed inside `<AuthFlow.Phone>`, pass
   * `PhoneAuthStep.ENTER_PHONE` to mirror the old phone header: title and
   * description hide after the user advances past that step.
   */
  showOnlyWhilePhoneStep?: PhoneAuthStep;
}
export function AuthFlowHeader(t0) {
  const $ = _c(10);
  const {
    title,
    description,
    className,
    showOnlyWhilePhoneStep
  } = t0;
  const {
    state
  } = useAuthFlow();
  const phone = usePhoneAuthOptional();
  if (state.isInSubFlow) {
    return null;
  }
  if (showOnlyWhilePhoneStep !== undefined && phone) {
    if (phone.state.step !== showOnlyWhilePhoneStep) {
      return null;
    }
  }
  if (!title && !description) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cx("w-full space-y-2 text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title && <h2 className="text-h3 font-medium">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = description && <p className="text-body text-foreground-secondary">{description}</p>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}